export const leadingZero = (number, place = 2) => {
  return String(number).length === place ? number : `0${number}`;
};
